<template>
	<li>
		<button :class="{ open: show }" @click="toggleShow()" :aria-expanded="show ? 'true' : 'false'">
			<h3><slot name="question"></slot></h3><span class="plus"></span>
		</button>
		<div class="answer" ref="answer">
			<slot name="answer"></slot>
		</div>
	</li>
</template>

<script>
export default {
	props: ['question', 'currentQuestion'],

	data() {
		return {
			show: this.currentQuestion == this.question
		}
	},

	methods: {
		toggleShow() {
			this.show = !this.show;
			this.$emit('click', this.question);
		}
	},

	watch: {
		currentQuestion(newValue, oldValue) {
			if (this.currentQuestion && newValue !== this.question) {
				this.show = false;
			} else if(this.currentQuestion && newValue == this.question) {
				this.show = true;
			}
		},

		show(newValue) {
			Velocity(this.$refs.answer, newValue ? 'slideDown' : 'slideUp', {duration: 250});
		}
	}
}
</script>